<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <div>
      <!--   Coupon settings card-->
      <app-admin-card-with-title [cardTitle]="t('administrator.discounts.discount.details')"
                                 [isContentVisible]="!isCouponSettingsCollapsed"
                                 [removeTopMargin]="true">
        <div class="mb-4">
          <div class="row">
            <div class="col-12 col-md-6 col-xxl-3">
              <app-select formControlName="discountType" [items]="[1,2,3,4]" [labels]="['administrator.discounts.management.discountType.1',
                              'administrator.discounts.management.discountType.2','administrator.discounts.management.discountType.3',
                               'administrator.discounts.management.discountType.4' ]"
                          label="administrator.discounts.management.discountType"/>
            </div>
            <div class="col-12 col-md-6 col-xxl-3">
              <app-input formControlName="discountCode" label="administrator.discounts.management.discountCode"
                         cssClass="flex-grow-1"/>
            </div>
            <div class="col-12 col-md-6 col-xxl-3">
              <app-input formControlName="name" label="administrator.discounts.management.name"
                         cssClass="flex-grow-1"/>
            </div>
            <div class="col-12 col-md-6 col-xxl-3">
              <app-input formControlName="description" label="administrator.discounts.management.description"
                         cssClass="flex-grow-1"/>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 col-xxl-3">
              <app-select formControlName="discountApplication" [items]="[1,2]" [labels]="['administrator.discounts.management.applicationOfDiscount.percentages',
                              'administrator.discounts.management.applicationOfDiscount.fixedAmount' ]"
                          label="administrator.discounts.management.applicationOfDiscount"/>
            </div>
            <div class="col-12 col-md-6 col-xxl-3">
              <app-input type="number" formControlName="amountOrPercentage"
                         label="administrator.discounts.management.amountOrPercentage"/>
            </div>
            <div class="col-12 col-xxl-6">
              <div class="mb-3">
                <app-date-time-from-to-input formControlName="periodValidation"
                                             [labelStart]="t('administrator.discounts.management.datePeriodValidation.from')"
                                             [labelEnd]="t('administrator.discounts.management.datePeriodValidation.to')"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-3 col-md-6 col-xxl-3">
              <app-select formControlName="whatDiscountCovers" [items]="[1,2]" [labels]="['administrator.discounts.management.whatDiscountCovers.registrationFee',
                              'administrator.discounts.management.whatDiscountCovers.allChargesItems' ]"
                          label="administrator.discounts.management.whatDiscountCovers"/>
            </div>
            <div class="col-12 col-md-3 col-md-6 col-xxl-3">
              <app-select formControlName="usageLimit" [items]="[1,2]" [labels]="['administrator.discounts.management.usageLimit.yes',
                              'administrator.discounts.management.usageLimit.no' ]"
                          label="administrator.discounts.management.usageLimit"/>
            </div>
            <div class="col-12 col-md-3 col-md-6 col-xxl-3">
              <app-input type="number" formControlName="usageMaxAllowed"
                         label="administrator.discounts.management.maxAllowed"/>
            </div>
            <div class="col-12 col-md-3 col-md-6 col-xxl-3">
              <div class="d-flex align-items-top mb-3">
                <div class="flex-grow-1">
                  <app-select formControlName="standaloneUsageOfDiscount" [items]="[1,2]" [labels]="['administrator.discounts.management.singleUsageOfDiscount.yes',
                              'administrator.discounts.management.singleUsageOfDiscount.no' ]"
                              label="administrator.discounts.management.singleUsageOfDiscount"/>
                </div>
                <div class="info-box">
                  <i class="bi bi-info-circle info-icon"
                     ngbTooltip="{{ t('administrator.discounts.management.singleUsageOfDiscount.label') }}"
                     placement="left"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-3">
              <app-select formControlName="discountOnMoreRaces" [items]="[1,2]" [labels]="['administrator.discounts.management.discountOnMoreRaces.yes',
                              'administrator.discounts.management.discountOnMoreRaces.no' ]"
                          label="administrator.discounts.management.discountOnMoreRaces"/>
            </div>
            <div class="col-12 col-md-3 mb-3">
              <div class="input-group d-flex flex-nowrap align-items-center">
                <div class="flex-grow-1">
                  <app-tags-input [inputLabel]="t('administrator.discounts.management.numberOfRaces')"
                                  [disabled]="isDiscountOnMoreRacesItemsFieldDisabled()"
                                  [tags]="inputForm.controls['numberOfRaces'].value"
                                  [isRequired]="inputForm.controls['numberOfRaces'].errors?.['required']"
                                  [showErrorMessage]="inputForm.controls['numberOfRaces'].touched"
                                  [errors]="inputForm.controls['numberOfRaces'].errors"
                                  (onTagRemoved)="onRemoveDiscountItem($event)" [readonly]="true"
                                  [cssClass]="'remove-border-right-radius'"/>
                </div>
                <div class="info-box" (click)="addDiscountItem()">
                  <i class="bi bi-info-circle bi-tag large-icon"></i>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="input-group d-flex flex-nowrap align-items-center">
                <div class="flex-grow-1">
                  <app-tags-input
                    [inputLabel]="t('administrator.discounts.management.eventsRacesDiscountIsAppliedTo')"
                    [tags]="inputForm.controls['eventsRacesDiscountIsAppliedTo'].value"
                    [isRequired]="inputForm.controls['eventsRacesDiscountIsAppliedTo'].errors?.['required']"
                    [showErrorMessage]="inputForm.controls['eventsRacesDiscountIsAppliedTo'].touched"
                    [errors]="inputForm.controls['eventsRacesDiscountIsAppliedTo'].errors"
                    (onTagRemoved)="onRemoveEventDiscountItem($event)" [readonly]="true"
                    [cssClass]="'remove-border-right-radius'"/>
                </div>
                <div class="info-box" (click)="openEventsForDiscountList()">
                  <i class="bi bi-info-circle bi-tag large-icon"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 col-xxl-3 mt-3 mt-md-0">
              <div class="d-flex align-items-center h-100">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="active" formControlName="active">
                  <label class="form-check-label" for="active">
                    {{ t("administrator.discounts.management.isCodeActive") }}
                    @if (inputForm.controls['active'].errors?.['required']) {
                      <span>*</span>
                    }
                  </label>
                  @if (inputForm.controls['active'].touched) {
                    @for (errorMessage of inputForm.controls['active']!.errors | errorMessages:'active';track
                      errorMessage) {
                      <span class="errorMes pt-1">{{ errorMessage }} </span>
                    }
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-admin-card-with-title>

      <app-action-buttons-row (onSave)="onSave()"/>
      @if (discount?.id && inputForm.controls.discountType.value ===
      DiscountType.COUPON) {
        <ng-container>
          <!--     Users who have used the coupon card-->
          <app-admin-card-with-title [cardTitle]="t('administrator.discounts.discount.listOfUsersHowHaveUsedTheCoupon')"
                                     [isContentVisible]="!isUserWhoHaveUsedTheCouponCollapsed"
                                     [showToggleButton]="true">
            <div slot="trailingWidget">
              <div class="pe-3">
                <app-rounded-button [label]="t('events.details.organiser.export.to.xls')"
                                    [btnClass]="'rounded-button--button-black-solid fs-14'"
                                    [isDisabled]="false">
                  <i class="bi bi-file-excel pe-2"></i>
                </app-rounded-button>
              </div>
            </div>
            <div>
              <div class="table-responsive d-xl-block d-none">
                <table [infiniteScrollDistance]="4" class="table table-last-row-no-border" infinite-scroll>
                  <thead>
                  <tr>
                    <th scope="col" class="id-column-width">{{ t("event.item.id") }}</th>
                    <th scope="col">{{ t("app.common.name.surname") }}</th>
                    <th scope="col">{{ t("app.common.mobilePhone") }}</th>
                    <th scope="col">{{ t("app.common.email") }}</th>
                    <th class="remove-column-width"></th>
                  </tr>
                  </thead>
                  <tbody>
                    @for (user of userWithUsedCoupons;track user) {
                      <tr>
                        <td class="center-align">{{ user.id }}</td>
                        <td class="center-align">{{ user.firstname ?? "" }} {{ user.lastname ?? "" }}</td>
                        <td class="center-align">{{ user.phoneNumber ?? "-" }}</td>
                        <td class="center-align" matTooltip="{{user.email ?? '-'}}">{{ user.email ?? "-" }}</td>
                        <td></td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <!--            Mobile-->
              @for (user of userWithUsedCoupons;track user;let isLast=$last) {
                <div class="d-block d-xl-none">
                  <div [class.isLastRow]="isLast" class="d-flex mobile-table-row">
                    <div [class.isLastRow]="isLast" class="d-flex flex-column">
                      <div>
                        <strong>{{ t("event.item.id") }}:</strong>{{ user.id }}
                      </div>
                      <div>
                        <strong>{{ t("app.common.name.surname") }}
                          :</strong>{{ user.firstname ?? "" }} {{ user.lastname ?? "" }}
                      </div>
                      <div>
                      </div>
                      <div>
                        <strong>{{ t("app.common.mobilePhone") }}:</strong>{{ user.phoneNumber ?? "-" }}
                      </div>
                      <div>
                        <strong>{{ t("app.common.email") }}:</strong>{{ user.email ?? "-" }}
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </app-admin-card-with-title>

          <!--     Users who have used the coupon card-->
          <app-admin-card-with-title
            [cardTitle]="t('administrator.discounts.discount.listOfUsersHowHaveNotUsedTheCoupon')"
            [isContentVisible]="!isUserWhoHaveNotUsedTheCouponCollapsed" [showToggleButton]="true">
            <div slot="trailingWidget">
              <div class="d-flex flex-row">
                <div class="pe-3">
                  <app-rounded-button [label]="t('administrator.discounts.discount.send.coupon.to.user')"
                                      [btnClass]="'rounded-button--red-outline fs-14'" (onClick)="openUsersList()"><i
                    class="bi bi-plus-circle pe-2"></i></app-rounded-button>
                </div>
                <div class="pe-3">
                  <app-rounded-button [label]="t('events.details.organiser.export.to.xls')"
                                      [btnClass]="'rounded-button--button-black-solid fs-14'"
                                      [isDisabled]="false">
                    <i class="bi bi-file-excel pe-2"></i>
                  </app-rounded-button>
                </div>
              </div>
            </div>
            <div>
              <div class="table-responsive d-xl-block d-none">
                <table [infiniteScrollDistance]="4" class="table table-last-row-no-border" infinite-scroll>
                  <thead>
                  <tr>
                    <th scope="col" class="id-column-width">{{ t("event.item.id") }}</th>
                    <th scope="col">{{ t("app.common.name.surname") }}</th>
                    <th scope="col">{{ t("app.common.mobilePhone") }}</th>
                    <th scope="col">{{ t("app.common.email") }}</th>
                    <th class="remove-column-width"></th>
                  </tr>
                  </thead>
                  <tbody>
                    @for (user of userWithUnusedCoupons;track user) {
                      <tr>
                        <td class="center-align">{{ user.id }}</td>
                        <td class="center-align">{{ user.firstname ?? "" }} {{ user.lastname ?? "" }}</td>
                        <td class="center-align">{{ user.phoneNumber ?? "-" }}</td>
                        <td class="center-align" matTooltip="{{user.email ?? '-'}}">{{ user.email ?? "-" }}</td>
                        <td class="text-end center-align">
                          <span class="edit-icon cursor-pointer" (click)="removeCouponFromUser(user)"><i
                            class="bi bi-dash-circle"></i></span>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <!--            Mobile-->
              @for (user of userWithUnusedCoupons;let isLast=$last;track user) {
                <div class="d-block d-xl-none">
                  <div [class.isLastRow]="isLast" class="d-flex mobile-table-row">
                    <div [class.isLastRow]="isLast" class="d-flex flex-column">
                      <div>
                        <strong>{{ t("event.item.id") }}:</strong>{{ user.id }}
                      </div>
                      <div>
                        <strong>{{ t("app.common.first.name") }}
                          :</strong>{{ user.firstname ?? "" }} {{ user.lastname ?? "" }}
                      </div>
                      <div>
                        <strong>{{ t("app.common.mobilePhone") }}:</strong>{{ user.phoneNumber ?? "-" }}
                      </div>
                      <div>
                        <strong>{{ t("app.common.email") }}:</strong>{{ user.email ?? "-" }}
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </app-admin-card-with-title>
        </ng-container>
      }
    </div>
  </form>
</ng-container>
